import React from 'react';
import { Title } from '../components/ui/Title';

function Privacy() {
  return (
    <div className="container mx-auto px-6 py-8 md:py-24">
      <Title>Privacy Policy</Title>
      
      <div className="max-w-3xl mx-auto panel">
        <div className="prose prose-invert">
          <h2 className="text-2xl font-semibold mb-6">Data Protection</h2>
          
          <div className="space-y-6 text-light/80">
            <p>
              We take the protection of your personal data very seriously. We treat your personal
              data confidentially and in accordance with the statutory data protection regulations
              and this privacy policy.
            </p>

            <h3 className="text-xl font-semibold mt-8 mb-4">Data Collection</h3>
            <p>
              The following data is collected when you register and use our platform:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Email address</li>
              <li>Username</li>
              <li>Profile information (optional)</li>
              <li>Usage data</li>
            </ul>

            <h3 className="text-xl font-semibold mt-8 mb-4">Data Usage</h3>
            <p>
              We use your data to:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Provide and improve our services</li>
              <li>Communicate with you</li>
              <li>Ensure platform security</li>
            </ul>

            <h3 className="text-xl font-semibold mt-8 mb-4">Your Rights</h3>
            <p>
              You have the right to:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to data processing</li>
            </ul>

            <h3 className="text-xl font-semibold mt-8 mb-4">Services and Tools</h3>
          <h4>Google reCAPTCHA</h4>
          <p>
            To protect our forms, we use Google reCAPTCHA, which helps prevent misuse through automated access. When using this service, data such as your IP address or mouse movements may be transmitted to Google.
          </p>

          <h4>Google Maps</h4>
          <p>
           We use Google Maps to display maps. In doing so, data such as your IP address may be transmitted to Google servers in the USA and stored there. The processing is based on our legitimate interest in accordance with Art. 6(1)(f) GDPR.
          </p>

          <h4>OAuth</h4>
          <p>
          For user authentication, we use OAuth, a secure authorization framework that allows users to log in using third-party providers (such as Google or Facebook) without sharing their passwords with us. During this process, certain user data (e.g., name, email address) may be transmitted by the respective provider to our system, depending on the provider’s privacy policy and the permissions granted by the user. The processing of this data is carried out in accordance with Art. 6(1)(b) GDPR (performance of a contract) or Art. 6(1)(a) GDPR (consent), if applicable.
          </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Privacy;